import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.shareable-passenger-page.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.shareable-passenger-page.description',
    defaultMessage: '',
  },
  shareablePassengerPageTitle: {
    id: 'cc4.form.shareable-passenger-page.title',
    defaultMessage: `{mainbooker} and you might receive {amount} each in compensation for your delayed flight!`,
  },
  shareablePassengerRefundPageTitle: {
    id: 'cc4.form.shareable-passenger-page.refund-title',
    defaultMessage: `We believe you and {mainbooker} are entitled to the complete refund of your ticket!`,
  },
  shareablePassengerPageSubTitle: {
    id: 'cc4.form.shareable-passenger-page.sub-title',
    defaultMessage: `Fill in your details`,
  },
  shareablePassengerPageDescription: {
    id: 'cc4.form.shareable-passenger-page.description',
    defaultMessage: `You just need to provide some information required by the airline. We will make sure to get you your compensation as quickly as possible!`,
  },
  shareablePassengerPagePermissionDescription: {
    id: 'cc4.form.shareable-passenger-page.permission-description',
    defaultMessage: `We need a signed Power of Attorney to represent you and your co-passengers.`,
  },
  shareablePassengerPageMainBookerPermissionDescription: {
    id: 'cc4.form.shareable-passenger-page.main-booker-permission-description',
    defaultMessage: `We need a signed Power of Attorney to represent you.`,
  },
  claimAccountGrantPermissionForPassengerHeader: {
    id:
      'cc4.form.claim-account.documents.grant-permission-for-passenger-header',
    defaultMessage: 'Grant us permission to handle the claim of {passenger}',
  },
  submitContinue: {
    id: 'cc4.form.shareable-passenger-page.button.submit-continue',
    defaultMessage: 'Continue',
  },
  asideText: {
    id: 'cc4.form.shareable-passenger-page.aside-text',
    defaultMessage: 'Disrupted flight',
  },
  mainBookerInfoCompensationTitle: {
    id: 'cc4.form.main-booker-info.compensation-title',
    defaultMessage: 'Good news! You may be entitled to {amount}',
  },
  mainBookerInfoDescription: {
    id: 'cc4.form.main-booker-info.compensation-description',
    defaultMessage: `You just need to provide some information required by the airline. We will make sure to get you your compensation as quickly as possible!`,
  },
  mainBookerInfoTicketRefundTitle: {
    id: 'cc4.form.main-booker-info.ticket-refund-title',
    defaultMessage:
      'We believe you are entitled to the complete refund of your ticket!',
  },
  sharableClaimPageTitle: {
    id: 'cc4.form.shareable-claim-page-minor.title',
    defaultMessage: `Complete permission to handle claim for {minor}`,
  },
  sharableClaimPageDescription: {
    id: 'cc4.form.shareable-claim-page-minor.description',
    defaultMessage: `You just need to provide some information required by the airline. We will make sure to get you your compensation as quickly as possible!`,
  },
  fillInMinorDetails: {
    id: 'cc4.form.shareable-claim-page-minor.sub-title',
    defaultMessage: `Fill in minor's details`,
  },
  minorBirthdateAlert: {
    id: 'cc4.form.shareable-claim-page-minor.alert',
    defaultMessage: `The date of birth does not correspond to a minor. Please check again or <cta>upgrade the passenger to an adult</cta> profile.`,
  },
});
